import React from 'react'
import { Message } from '@paypalcorp/worldready-react'
import {
  ICON_WALLET,
  WALLET_OFFER_URL,
  WALLET_OFFER_REDIRECT_FLOW_QUERY_PARAM
} from './lib/client-constants'
import TextLink from './TextLink'

interface Props {
  encryptedOfferId: string | null
}

const OfferDetailsModalSavedToWallet = ({ encryptedOfferId }: Props) => {
  return (
    <div className="offer-details-modal-savedtowallet">
      <img
        className="offer-details-modal-savedtowallet__walletIcon"
        src={ICON_WALLET}
      />
      <div className="offer-details-modal-savedtowallet__saved ppvx_text--body">
        <Message id="main.shoppingHub.modal.offerDetails.savedToWallet" />
      </div>
      <TextLink
        href={
          WALLET_OFFER_URL +
          encryptedOfferId +
          WALLET_OFFER_REDIRECT_FLOW_QUERY_PARAM
        }
      >
        <div className="offer-details-modal-savedtowallet__wallet ppvx_text--body-strong">
          <Message id="main.shoppingHub.modal.offerDetails.openWallet" />
        </div>
      </TextLink>
    </div>
  )
}

export default OfferDetailsModalSavedToWallet
